import { Component, OnInit } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

import { FormsModule } from '@angular/forms';
import { NgxIntlTelInputModule } from 'untold-ngx-intl-tel-input';
import { TranslatePipe } from '@ngx-translate/core';


@Component({
    selector: 'app-confirm-delete-multiple-modal',
    templateUrl: './confirm-delete-multiple-modal.component.html',
    styleUrls: ['./confirm-delete-multiple-modal.component.scss'],
    imports: [FormsModule, NgxIntlTelInputModule, TranslatePipe],
    standalone: true
})
export class ConfirmDeleteMultipleModalComponent implements OnInit {


  public question;
  public showNotifyClientOption = false;
  public notifyClient = true;
  public submitted = false;

  constructor(
    private bsModalRef: BsModalRef,
    private modalService: BsModalService) { }

  ngOnInit() {
  }

  close(confirm, confirmAll ) {
    if (this.submitted) {
      return;
    }
    this.submitted = true;

    if (confirm && !confirmAll) {
      this.modalService.setDismissReason('confirm');
    }

    if (!confirm && confirmAll) {
      this.modalService.setDismissReason('confirmAll');
    }

    this.bsModalRef.hide();
  }


}
